/**
 * Browser-side preview for promo/activity uploads. The source (which of the two
 * activity-calendar file families) + the "as of …" snapshot tag are encoded in
 * the FILENAME; the workbook itself is a heterogeneous matrix parsed entirely on
 * the server. So the preview only validates + reads the filename, mirroring
 * PromoActivityFileParser.parse_filename (the server stays authoritative).
 */

export async function parsePromoActivityForPreview(file: File): Promise<Record<string, unknown>> {
  const base = file.name
  const low = base.toLowerCase()

  if (!low.endsWith(".xlsx")) {
    throw new Error(`Format tidak didukung: "${base}". Activity plan hanya menerima .xlsx.`)
  }

  let source: string | null = null
  if (low.includes("marketing plan activity") || low.includes("mkt-activity")) {
    source = "mkt_activity_plan"
  } else if (low.includes("brand activities") || (low.includes("activit") && low.includes("ka"))) {
    source = "tm_activity_x_mkt"
  }

  if (!source) {
    throw new Error(
      `Jenis file activity tidak dikenali dari nama: "${base}" ` +
        `(harus "…MARKETING PLAN ACTIVITY…" atau "…KA - Brand Activities…").`,
    )
  }

  const stem = base.replace(/\.xlsx$/i, "")
  const m = stem.match(/(?:up to|as of)\s+(.+)$/i)
  const snapshotLabel = (m ? m[1] : stem).trim()

  return { source, snapshotLabel }
}
